import axios from 'axios';
import { url } from '../../../../../../../App';
import { useEffect, useState } from 'react';
import { useBorrowerContext } from '../../../../store/borrower-details';
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
const useAccountAggregator = () => {
    const navigate = useNavigate();
    const token = Cookies.get('Token');
    const email = Cookies.get('Email');
    // eslint-disable-next-line 
    const [user, setuser] = useState();
    // eslint-disable-next-line 
    const [loanNumber, setloanNumber] = useState(null);
    const BorrowerContextData = useBorrowerContext();
    const { fetchData } = useBorrowerContext()
    const { loanid } = useParams();
    let loan = null;
    // eslint-disable-next-line 
    const [banktype, setbanktype] = useState("Select Bank");
    // eslint-disable-next-line 
    const [aaResult, setaaResult] = useState(null)
    const [isCustomMode, setIsCustomMode] = useState(false);
    const [customNumber, setCustomNumber] = useState('');
    const [verifyModalOpen, setVerifyModalOpen] = useState(false);
    const [aa_link, setaa_link] = useState(null)
    const [underwritingstatus, setunderwritingstatus] = useState("NOT STARTED")
    const [monitoring, setmonitoring] = useState("NOT STARTED");
    // eslint-disable-next-line 
    const [MonitoringJSON, setMonitoringJSON] = useState(null);
    const [analyticsData, setanalyticsData] = useState(null);
    const [loading, setloading] = useState(true)
    const [monitoringJSONLoder, setmonitoringJSONLoder] = useState(true)
    // eslint-disable-next-line
    const [fromDate, setFromDate] = useState("");
    // eslint-disable-next-line
    const [toDate, setToDate] = useState("");
    const [banks, setbanks] = useState([]);
    const [aaSelectedbank, setaaSelectedbank] = useState(["Select Bank"]);
    const handleCloseModal = () => {
        setVerifyModalOpen(false);
        setIsCustomMode(false);
        setCustomNumber('');
    };
    // fetchData()
    // eslint-disable-next-line 
    loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]
    function startMonitoring() {
        if (!aaSelectedbank) {
            toast.error("Please select the bank type !")
            return;
        }
        if (underwritingstatus === "NOT STARTED" || monitoring === "NOT STARTED") {
            toast.error("AA tracking is not initiate !")
            return;
        }
        setloading(true)
        // eslint-disable-next-line 
        loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]
        console.log("loans data starting -> ", loan?.aa_consentStart_date)
        const today = new Date();
        const twelveMonthsAgo = new Date();
        twelveMonthsAgo.setMonth(today.getMonth() - 12);
          const now = new Date();
        const next12Months = new Date(now);
        next12Months.setMonth(now.getMonth() + 12);

        console.log(now.toISOString());           
        console.log(next12Months.toISOString());

        let data = JSON.stringify({
            "email": email,
            "trackingId": loan?.trackingId,
            "token": token,
            "fromDate": loan?.aa_consentStart_date ? loan?.aa_consentStart_date : today.toISOString(),
            "todate": loan?.aa_consentExpiry_data ? loan?.aa_consentExpiry_data : next12Months.toISOString(),
            // "fromDate":  today.toISOString(),
            // "todate":  next12Months.toISOString(),
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url + '/borrower/aa/startMonitoring',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                if (response.data.auth) {
                    toast.success("Monitoring is start successfully !")
                }
                else {
                    toast.error(response.data.message)
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setloading(false)
            })
    }
    function CheckMonitoringStatus() {

        setloading(true)
        // eslint-disable-next-line 
        loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]
        let data = JSON.stringify({
            "email": email,
            "trackingId": loan?.trackingId,
            "token": token,
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url + '/borrower/aa/MonitoringStatus',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log((response.data));
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setloading(false)
            })
    }
    function FetchMonitoringJSON() {
        setmonitoringJSONLoder(true)
        // eslint-disable-next-line 
        loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]

        let data = JSON.stringify({
            "email": email,
            "trackingId": loan?.trackingId,
            "token": token,
            "from": loan?.aa_consentStart_date,
            "to": loan?.aa_consentExpiry_data,
            "LoanId":loanid
            
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url + '/borrower/aa/GetMonitoringJSON',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                if(!response?.data?.auth)
                {
                    toast.error(response?.data?.message)
                }
                console.log("Monitoring json->", (response.data));
                setMonitoringJSON(response.data)
                setanalyticsData(response?.data?.data?.analytics)
                console.log("analyticsData-> ", analyticsData)
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setmonitoringJSONLoder(false)
            })
    }
    function refresh() {
        // fetchData()
        setloading(true)
        // eslint-disable-next-line 
        loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]
        // console.log("target number-> ", isCustomMode ? customNumber : loan?.business_phone_number)
        if (!loan?.trackingId) {
            toast.error("trackingId is not found Please initiate AA Tracking...!")
            setloading(false)
            return;
        }
        let data = JSON.stringify({
            "email": email,
            "token": token,
            "trackingId": loan?.trackingId,
            "borrower_uniqueno": BorrowerContextData?.borrowerData?.borrower?.borrower_uniqueno,
            "loan_id": loan?.loan_id
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url + `/borrower/aa/statuscheck`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                setunderwritingstatus(response?.data?.message?.data?.status_underwriting);
                setmonitoring(response?.data?.message?.data?.status_monitoring);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setloading(false)
            })
        // fetchData()
        // toast.success("Data fetched successfully !");
        // FetchMonitoringJSON();

    }
    useEffect(() => {
        setloading(true)
        console.log("BorrowerContextData-> ", BorrowerContextData?.borrowerData)
        // console.log("loanid-> ", loanid)
        // eslint-disable-next-line 
        loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]
        axios
            .post(url + "/user/getsingle", {
                token: token,
                email: email,
                useremail: email
            })
            .then((res) => {
                console.log("user res->", res);
                setuser(res?.data[0])
                if (res.data.logout === true) {
                    toast.error(res.data.message, {
                        style: {
                            background: "#fab6bb",
                            color: "red",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                    setTimeout(() => {
                        navigate("/");
                    }, 3000);
                }
                else {
                    console.log("permissions-> ", res?.data[0]?.permission)
                }
            })
            .catch((err) => {
                toast.error(err, {
                    style: {
                        background: "#fab6bb",
                        color: "red",
                        fontSize: "16px",
                        borderRadius: "1rem",
                        borderColor: "white"
                    },
                });
            }).finally(() => {
                setloading(false)
            })
        setloading(true)
        // eslint-disable-next-line 
        loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]
        let data = JSON.stringify({
            "email": email,
            "token": token
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url + `/borrower/aa/bankdropdownarray`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                setbanks(response.data.data)
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                console.log("result->", aaResult)
                setloading(false)
            })
        refresh();
        FetchMonitoringJSON();
        CheckMonitoringStatus();
        // fetchData()
        //eslint-disable-next-line
    }, [token, email]);

    function Bankdropdownarray() {
        //checking the borrower back account is present in aa or not 
        // setloading(true)
        // eslint-disable-next-line 
        // loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]
        // let data = JSON.stringify({
        //     "email": email,
        //     "token": token
        // });

        // let config = {
        //     method: 'post',
        //     maxBodyLength: Infinity,
        //     url: url + `/borrower/aa/bankdropdownarray`,
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     data: data
        // };

        // axios.request(config)
        //     .then((response) => {

        //         console.log(response.data.data.filter((val) => val.enabled === true));
        //         // eslint-disable-next-line 
        //         loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]

        //         if (banktype === "collection_bank") {
        //             if (!loan?.collection_bank_name) {
        //                 toast.error("Collection bank not found for this loan !")
        //                 return;
        //             }
        //             console.log("loan bank-> ", loan.collection_bank_name)
        //             // eslint-disable-next-line 
        //             let result = response.data.data.filter((val) => (val.name == loan?.collection_bank_name))
        //             console.log("result-> ", result)
        //             // eslint-disable-next-line 
        //             if (result?.length == 0) {
        //                 console.log("bank not found !")
        //                 toast.error("Bank not found in Account Aggregator !")
        //             }
        //             else {
        //                 setaaResult(result)
        //             }
        //         }
        //         else if (banktype === "disbursement_bank") {
        //             if (!loan?.disbursement_bank_name) {
        //                 toast.error("Disbursement bank not found for this loan !")
        //                 return;
        //             }
        //             console.log("loan bank-> ", loan?.disbursement_bank_name)
        //             // eslint-disable-next-line 
        //             let result = response.data.data.filter((val) => (val.name == loan?.disbursement_bank_name))
        //             console.log("result-> ", result)
        //             // eslint-disable-next-line 
        //             if (result?.length == 0) {
        //                 toast.error("Bank not found in Account Aggregator !")
        //                 return;
        //             }
        //             else {
        //                 setaaResult(result)
        //             }
        //         }

        //     })
        //     .catch((error) => {
        //         console.log(error);
        //     }).finally(() => {
        //         console.log("result->", aaResult)
        //         setloading(false)
        //     })

    }
    useEffect(() => {
        Bankdropdownarray();
        // eslint-disable-next-line 
    }, [banktype])
    useEffect(()=>{
      console.log("aaSelectedbank-> ",aaSelectedbank)
    },[aaSelectedbank])
    function InitiateConsent() {
        setloading(true)
        console.log("setaaSelectedbank-> ", aaSelectedbank)
        if (!aaSelectedbank || aaSelectedbank.length===0 || aaSelectedbank==="Select Bank") {
            toast.error("Bank is not selected !")
            setloading(false)
            return;
        }
        // eslint-disable-next-line 
        loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]
        // console.log("target number-> ", isCustomMode ? customNumber : loan?.business_phone_number)
        let data = JSON.stringify({
            "email": email,
            "token": token,
            "borrower_uniqueno": loan?.borrower_uniqueno,
            "aa_fipId": aaSelectedbank,
            "Phone_number": isCustomMode ? customNumber : loan?.mobile,
            "LoanId": loan?.loan_id
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url + `/borrower/aa/initiate`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                if (response?.data?.auth) {
                    toast.success(response?.data?.message);
                    setaa_link(response?.data?.data?.aa_link);
                    refresh();
                    Bankdropdownarray()
                    handleCloseModal();

                }
                else {
                    toast.error(response?.data?.message)
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                // refresh();
                fetchData()
                setloading(false)
            })

    }
    function PullReports() {
        setloading(true)
        // eslint-disable-next-line 
        loan = BorrowerContextData?.borrowerData?.loan.filter((val) => val.loan_id == loanid)[0]
        // console.log("target number-> ", isCustomMode ? customNumber : loan?.business_phone_number)
        if (!loan?.trackingId) {
            toast.error("trackingId is not found Please initiate AA Tracking...!")
            setloading(false)
            return;
        }
        let data = JSON.stringify({
            "email": email,
            "token": token,
            "trackingId": loan?.trackingId,
            "borrower_uniqueno": BorrowerContextData?.borrowerData?.borrower?.borrower_uniqueno,
            "loan_id": loan?.loan_id
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url + `/borrower/aa/pullReports`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log("pull Reports-> ", response.data);
                if (response.data.auth) {
                    toast.success(response.data.message)
                }
                else {
                    toast.error(response.data.message)
                }
                fetchData()
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setloading(false)
            })
    }
    // useEffect(() => {
    //     refresh();
    //     // eslint-disable-next-line
    // }, [InitiateConsent])
    // Add this function inside your AccountAggregator component
    const copyToClipboard = async (text) => {
        try {
            // Method 1: Modern clipboard API
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
                toast.success("Link copied to clipboard!");
                return true;
            }

            // Method 2: Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);

            if (successful) {
                toast.success("Link copied to clipboard!");
                return true;
            } else {
                throw new Error('Copy command failed');
            }
        } catch (err) {
            console.error('Failed to copy:', err);
            toast.error("Unable to copy link. Please manually copy the URL.");
            return false;
        }
    };
    return {
        BorrowerContextData, banktype, setbanktype, loan, InitiateConsent, isCustomMode, setIsCustomMode, customNumber, setCustomNumber, refresh, handleCloseModal, verifyModalOpen, setVerifyModalOpen, aa_link, underwritingstatus, setunderwritingstatus, monitoring, setmonitoring, startMonitoring, analyticsData, FetchMonitoringJSON, CheckMonitoringStatus, fetchData, loading, monitoringJSONLoder, PullReports, setFromDate, setToDate, fromDate, toDate, copyToClipboard, banks, aaSelectedbank, setaaSelectedbank
    }
}
export default useAccountAggregator;